<template>
  <div class="hello">
    <Top></Top>
    <!-- top swiper start -->
    <div class="swiper-container" @mouseover="stopSwiper" @mouseout="startSwiper">
      <div class="swiper-wrapper swiper-no-swiping" >
        <div class="swiper-slide">
          <div class="content bgImgCss videoBg">
            <video
              id="my_video_1"
              autoplay="autoplay"
              muted="muted"
              loop
              class="imgSrcCss videoHeight"
              preload="auto"
              data-setup="{}"
              width="100%"
            >
              <source :src="topSwiper" type="video/mp4">
            </video>
            <div class="contentPosition">
              <div class="contentTop">
                <span class="spanCss">
                  AI
                  <span class="addCss">+</span>
                </span>赋能 开启线下商显未来
              </div>
              <!-- <div class="contentBottom">
                <div class="contentBox">屏幕化社会</div>
                <div class="contentBox">屏幕化服务</div>
                <div class="contentBox">屏幕化生活</div>
              </div>-->
              <div class="wisdomCss">数拓 智见未来</div>
            </div>
          </div>
        </div>
        <!-- <div class="swiper-slide ">
          <div class="content bgImgCss">
            <img :src="bgImg" alt="" class="imgSrcCss">
            <div class="contentPosition">
              <div class="contentTop">智见未来</div>
              <div class="contentBottom">
                <div class="contentBox">屏幕化社会</div>
                <div class="contentBox">屏幕化服务</div>
                <div class="contentBox">屏幕化生活</div>
              </div>
            </div>
          </div>
        </div>-->
        <div class="swiper-slide">
          <div class="content bgImgCss">
            <img :src="topBanner3" ref="imgDom" alt class="imgSrcCss">
            <!-- <div class="maskBox" :style="{ height: maskBoxHeight +'px'}"></div> -->
            <div class="contentPositionTwo">
              <div class="contentTopTwo">屏幕无处不在</div>
              <div class="positionTextCss">“多屏时代，屏幕构成了一个完整的商业消费生态”</div>
              <div class="positionTextCss textRight">——凯文·凯利</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination"></div>
      <!-- 如果需要分页器 -->
    </div>
    <!-- top swiper end -->
    <!-- start -->
    <!-- content下边的列表展示 -->
    <div class="listBox">
      <div class="listTitle">全行业方案制定</div>
      <div class="listSpan">深度剖析行业背景，全面挖掘市场需求，为品牌提供定制化智能升级方案</div>
      <div class="imgListBox">
        <div
          class="imgBox"
          :style="{borderRight: index == 4 ? '0px':''}"
          v-for=" (value,index) in listImg"
          v-on:mouseover="changeActive(index)"
          v-on:mouseout="removeActive(index)"
        >
          <img :src="value" v-if="index == 0" alt @click="toPage('Plan/PlanNewRestaurant')">
          <img :src="value" v-if="index == 1" @click="toPage('Plan/PlanNewRetail')">
          <img :src="value" v-if="index == 2" @click="toPage('Plan/PlanDetail')">
          <img :src="value" v-if="index == 3" @click="toPage('Plan/PlanShowroom')">
          <img :src="value" v-if="index == 4" @click="toPage('Plan/PlanCinemaDetail')">
          <div v-if="index == 0" @click="toPage('Plan/PlanNewRestaurant')">新餐饮</div>
          <div v-if="index == 1" @click="toPage('Plan/PlanNewRetail')">新零售</div>
          <div v-if="index == 2" @click="toPage('Plan/PlanDetail')">智慧门店</div>
          <div v-if="index == 3" @click="toPage('Plan/PlanShowroom')">智慧展厅</div>
          <div v-if="index == 4" @click="toPage('Plan/PlanCinemaDetail')">智慧影院</div>
        </div>
        <!-- <div class="imgBox" v-for=" (value,index) in textArray">
          <div>{{value}}</div>
        </div>-->
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="twoContent">
      <!-- <img :src="bgImgTwo" alt="" class="twoContentImg"> -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition" v-on:mouseover="showBreathLight0" @mouseout='hiddleBreathLight0'>
        <transition name="fade">
          <div v-show='light0Bol'>
            <img :src="lampImg1" class="hiddleCss" alt="">
            <div class="lampText hiddleCss">云平台</div>
          </div>
        </transition>

        <div class="lampContent">
          <div class="lamp breath_light">
          </div>
          <div class="wick breath_light"></div>
        </div>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition2" v-on:mouseover="showBreathLight1" @mouseout='hiddleBreathLight1'>
        <transition name="fade">
          <div v-show='light1Bol'>
            <img :src="lampImg2" class="hiddleCss" alt="">
            <div class="lampText hiddleCss">App Store</div>
          </div>
        </transition>

        <div class="lampContent">
          <div class="lamp breath_light1">
          </div>
          <div class="wick breath_light1"></div>
        </div>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition3" v-on:mouseover="showBreathLight2" @mouseout='hiddleBreathLight2'>
        <transition name="fade">
          <div v-show='light2Bol'>
            <img :src="lampImg3" class="hiddleCss" alt="">
            <div class="lampText hiddleCss">认证外设</div>
          </div>
        </transition>

        <div class="lampContent">
          <div class="lamp breath_light2">
          </div>
          <div class="wick breath_light2"></div>
        </div>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition4" v-on:mouseover="showBreathLight3" @mouseout='hiddleBreathLight3'>
        <transition name="fade">
          <div v-show='light3Bol'>
            <img :src="lampImg4" class="hiddleCss" alt="">
            <div class="lampText hiddleCss">数据银行</div>
          </div>
        </transition>

        <div class="lampContent">
          <div class="lamp breath_light3">
          </div>
          <div class="wick breath_light3"></div>
        </div>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition5">
        <div class="lampContent lampContentTwo" v-on:mouseover="showBreathLight4" @mouseout='hiddleBreathLight4'>
          <div class="lamp breath_light4">
          </div>
          <div class="wick breath_light4"></div>
        </div>
        <transition name="fade">
          <div v-show='light4Bol'>
            <img :src="lampImg5" class="hiddleCss hiddleCssTwo" alt="">
            <div class="lampText hiddleCss hiddleCssTwoText">互动感应</div>
          </div>
        </transition>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition6">
        <div class="lampContent lampContentTwo" v-on:mouseover="showBreathLight5" @mouseout='hiddleBreathLight5'>
          <div class="lamp breath_light5">
          </div>
          <div class="wick breath_light5"></div>
        </div>
        <transition name="fade">
          <div v-show='light5Bol'>
            <img :src="lampImg6" class="hiddleCss hiddleCssTwo" alt="">
            <div class="lampText hiddleCss hiddleCssTwoText">商显大脑</div>
          </div>
        </transition>


      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition7">


        <div class="lampContent lampContentTwo" v-on:mouseover="showBreathLight8" @mouseout='hiddleBreathLight8'>
          <div class="lamp breath_light6">
          </div>
          <div class="wick breath_light6"></div>
        </div>
        <transition name="fade">
          <div v-show='light8Bol'>
            <img :src="lampImg7" class="hiddleCss hiddleCssTwo" alt="">
            <div class="lampText hiddleCss hiddleCssTwoText">AI引擎</div>
          </div>
        </transition>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- start 呼吸灯 -->
      <!-- <div class="lampBox lampBoxPosition8">
        <transition name="fade">
          <div v-show='light7Bol' transiton="fade">
            <img :src="lampImg8" class="hiddleCss" alt="">
            <div class="lampText hiddleCss">H5容器</div>
          </div>
        </transition>
        <div class="lampContent" v-on:mouseover="showBreathLight7" @mouseout='hiddleBreathLight7'>
          <div class="lamp breath_light7">
          </div>
          <div class="wick breath_light7"></div>
        </div>
      </div>-->
      <!-- end 呼吸灯 -->
      <!-- 上面的文本 start -->
      <!-- <div class="twoContentText">
        <div class="twoTextTitle">
          数拓技术优势
        </div>
        <div class="twoText">
          数拓独创互联网化智屏OS，重构商业消费生态，帮助品牌实现全渠道一体化运营。通
          过场景化智屏APP，在全面升级消费体验的同时，让单个客户可识别，可触达，可实时交互反馈，通过大数据分析消费行为，消费动机，让品牌深入理解客户。
        </div>
      </div>-->
      <!-- 上面的文本 end -->
    </div>
    <!-- end -->
    <!-- 数拓技术优势 2.0  start -->
    <div class="advantage">
      <img :src="advantageBg" class="advantageImg" alt>
      <div class="advantageBox">
        <div class="advantageLeft">
          <div class="advleftBox">
            <div class="advTitle">数拓技术优势</div>
            <div
              class="advText"
            >数拓独创互联网化智屏OS，重构商业消费生态，帮助品牌实现全渠道一体化运营。通过场景化智屏APP，在全面升级消费体验的同时，让单个客户可识别、可触达、可实时交互反馈。通过大数据分析消费行为、消费动机，让品牌深入理解客户。</div>
          </div>
        </div>
        <div class="advantageRight">
          <div class="rightFlex">
            <div class="rightBox">
              <img :src="lampImg1" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <!-- <video :src="lampImg1"></video> -->
              <div>云平台</div>
            </div>
            <div class="rightBox">
              <img :src="lampImg2" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>H5容器</div>
            </div>
            <div class="rightBox">
              <img :src="lampImg3" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>AI引擎</div>
            </div>
            <div class="rightBox">
              <img :src="lampImg4" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>商显大脑</div>
            </div>
            <div class="rightBox marginTop84">
              <img :src="lampImg5" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>APP Store</div>
            </div>
            <div class="rightBox marginTop84">
              <img :src="lampImg6" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>认证外设</div>
            </div>
            <div class="rightBox marginTop84">
              <img :src="lampImg7" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>互动感应</div>
            </div>
            <div class="rightBox marginTop84">
              <img :src="lampImg8" :class=" isShowGif ? 'showGif': 'notShowGif' " alt>
              <div>大数据统计</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 数拓技术优势 2.0  end -->
    <div class></div>
    <ContentBottom></ContentBottom>
    <Footer></Footer>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import ContentBottom from "@/components/ContentBottom.vue";
import bgImg from "@/assets/images/banner-gw-01.png";
import topBanner3 from "@/assets/images/topBanner3.png";
import bgImgTwo from "@/assets/images/jishuyoushi-bg.png";
import lampIcon1 from "@/assets/images/showImg1.png";

// import lampImg1 from "@/assets/images/lampImg1.png";
// import lampImg2 from "@/assets/images/lampImg2.png";
// import lampImg3 from "@/assets/images/lampImg3.png";
// import lampImg4 from "@/assets/images/lampImg4.png";
// import lampImg5 from "@/assets/images/lampImg5.png";
// import lampImg6 from "@/assets/images/lampImg6.png";
// import lampImg7 from "@/assets/images/lampImg7.png";
// import lampImg8 from "@/assets/images/lampImg8.png";

import lampImg1 from "@/assets/images/gif1.gif";
import lampImg2 from "@/assets/images/h5Gif.gif";
import lampImg3 from "@/assets/images/aiGif.gif";
import lampImg4 from "@/assets/images/shangYeGif.gif";
import lampImg5 from "@/assets/images/appStoreGif.gif";
import lampImg6 from "@/assets/images/renZhengGif.gif";
import lampImg7 from "@/assets/images/huDongGif.gif";
import lampImg8 from "@/assets/images/bigDataGif.gif";

import topSwiper from "@/assets/images/globalSwiper.mp4";

import advantageBg from "@/assets/images/advantageBg.png";

export default {
  name: "HelloWorld",
  components: {
    Top,
    Footer,
    ContentBottom
  },
  data() {
    return {
      advantageBg: advantageBg,
      topSwiper: topSwiper,
      lampIcon1: lampIcon1,
      lampImg1: lampImg1,
      lampImg2: lampImg2,
      lampImg3: lampImg3,
      lampImg4: lampImg4,
      lampImg5: lampImg5,
      lampImg6: lampImg6,
      lampImg7: lampImg7,
      lampImg8: lampImg8,
      imgList: [
        {
          imgUrl: ""
        }
      ],
      bgImgTwo: bgImgTwo,
      topBanner3: topBanner3,
      textArray: ["新餐饮", "新零售", "智慧门店", "智慧展厅", "新院线"],
      listImg: [
        require("@/assets/images/listImg11.png"),
        require("@/assets/images/listImg12.png"),
        require("@/assets/images/listImg8.png"),
        require("@/assets/images/listImg13.png"),
        require("@/assets/images/listImg14.png")
      ],
      listImg1: [
        require("@/assets/images/listImg1.png"),
        require("@/assets/images/listImg3.png"),
        require("@/assets/images/listImg10.png"),
        require("@/assets/images/listImg9.png"),
        require("@/assets/images/listImg4.png")
      ],
      note: {
        height: "100%",
        backgroundSize: "100% 100%",
        backgroundImage:
          "url(" + require("@/assets/images/banner-gw-01.png") + ")"
      },
      bgImg: bgImg,
      light7Bol: false,
      light8Bol: false,
      light5Bol: false,
      light4Bol: false,
      light3Bol: false,
      light2Bol: false,
      light1Bol: false,
      light0Bol: false,
      mySwiper: "",
      maskBoxHeight: "",
      isShowGif: true
     
    };
  },

  mounted() {
    
    // 滚动事件
    window.addEventListener("scroll", this.menu);
    let _this = this;
    setTimeout(function() {
      _this.maskBoxHeight = _this.$refs.imgDom.offsetHeight;
    }, 10);

    this.mySwiper = new Swiper(".swiper-container", {
      //…其它配置项
      pagination: ".swiper-pagination", // 分页器类名
      // paginationElement: 'div', // 这里是指渲染的元素  跟paginationBulletRender中的div对应
      paginationClickable: true, // 这里是开启分页器的点击事件
      // paginationBulletRender(swiper, index, pagination) {
      //   return '<div class="' + pagination + '">' + items[index].xxx + '</div>';
      //   // 这里className表示默认的swiper分页器类名
      // }
      clickable: true,
      loop:true,
       prevButton: ".swiper-button-prev",
      nextButton: ".swiper-button-next",
      autoplay: 5000
    });
  },
  methods: {
    // 滚动事件
    menu() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 500) {
        this.isShowGif = true;
      }
    },
    toPage(val) {
      let routeUrl = this.$router.resolve({
        path: `${val}`
      });
      window.open(routeUrl.href, "_blank");
    },
    // 鼠标移入关闭轮播
    stopSwiper() {
      this.mySwiper.stopAutoplay();
    },
    // 鼠标移出后开启轮播
    startSwiper() {
      this.mySwiper.startAutoplay();
    },
    changeActive(index) {
      this.listImg[index] = this.listImg1[index];
      this.listImg.splice(index, 1, this.listImg1[index]);
    },
    removeActive(index) {
      this.listImg = [
        require("@/assets/images/listImg11.png"),
        require("@/assets/images/listImg12.png"),
        require("@/assets/images/listImg8.png"),
        require("@/assets/images/listImg13.png"),
        require("@/assets/images/listImg14.png")
      ];
    },
    // H5容器的hover
    showBreathLight7() {
      this.light7Bol = true;
    },
    hiddleBreathLight7() {
      this.light7Bol = false;
    },
    //  AI引擎
    showBreathLight8() {
      this.light8Bol = true;
    },
    hiddleBreathLight8() {
      this.light8Bol = false;
    },
    // 商显大脑
    showBreathLight5() {
      this.light5Bol = true;
    },
    hiddleBreathLight5() {
      this.light5Bol = false;
    },
    // 互动感应
    showBreathLight4() {
      this.light4Bol = true;
    },
    hiddleBreathLight4() {
      this.light4Bol = false;
    },
    // 数据银行
    showBreathLight3() {
      this.light3Bol = true;
    },
    hiddleBreathLight3() {
      this.light3Bol = false;
    },
    // 认证外设
    showBreathLight2() {
      this.light2Bol = true;
    },
    hiddleBreathLight2() {
      this.light2Bol = false;
    },
    // App Store
    showBreathLight1() {
      this.light1Bol = true;
    },
    hiddleBreathLight1() {
      this.light1Bol = false;
    },
    // 云平台
    showBreathLight0() {
      this.light0Bol = true;
    },
    hiddleBreathLight0() {
      this.light0Bol = false;
    }
  }
};
</script>

<style scoped>
.content {
  position: relative;
  /* min-width: 978px; */
}

.bgImgCss {
  width: 100%;
}

.imgSrcCss {
  width: 100%;
}

.contentBottom {
  display: flex;
  width: 601px;
  margin: auto;
  height: 29px;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

.contentBox {
  flex-grow: 1;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentTopTwo {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 180px;
  text-align: center;
}
.maskBox {
  position: absolute;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  z-index: 10;
}
.contentPositionTwo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 720px;
  height: 180px;
  z-index: 20;
  text-align: center;
}

.listBox {
  width: 70%;
  text-align: center;
  margin: auto;
}

.listTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin-top: 83px;
}

.pagination {
  width: 50px;
  border: 1px solid red;
}

.listSpan {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 34px;
  margin-top: 44px;
}

.imgListBox {
  display: flex;
  flex-wrap: wrap;
  margin-top: 90px;
}

.imgBox {
  width: 19%;
  margin-top: 20px;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 34px;
  transition: 0.5s;
  border-right: 1px solid rgba(236, 235, 235, 1);
  cursor: pointer;
}

.imgBox:hover {
  color: rgba(252, 200, 0, 1);
}

.imgBox img {
}

.twoContent {
  margin-top: 93px;
  position: relative;
}

.twoContentImg {
  width: 100%;
}

/* start */
.twoContentText {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 910px;
  height: 240px;
}

.twoTextTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.twoText {
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  margin-top: 82px;
}

.swiperBox {
  height: 300px;
  background: tomato;
}

/* end  */
.positionTextCss {
  height: 31px;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

.textRight {
  text-align: right;
  margin-top: 16px;
}

.swiper-pagination-bullet {
  width: 95px !important;
  height: 2px !important;
  opacity: 0.7 !important;
  background: #fff !important;
}

.swiper-pagination-bullet-active {
  background: #fff !important;
  opacity: 0.7 !important;
}

.lampContent {
  position: absolute;
  bottom: 0;
  width: 31px;
  height: 31px;
}

.lampContentTwo {
  position: absolute;
  top: 0;
  width: 31px;
  height: 31px;
}

.lamp {
  position: absolute;
  z-index: 20;
  width: 31px;
  height: 31px;
  background: rgba(255, 255, 255, 1);
  opacity: 0.26;
  border-radius: 50%;
}

.wick {
  position: absolute;
  top: calc(50% - 5px);
  left: calc(50% - 5px);
  z-index: 30;
  width: 9px;
  height: 9px;
  background: rgba(255, 255, 255, 1);
  border-radius: 50%;
  opacity: 1;
}

.lampBox {
  position: absolute;

  width: 128px;
  height: 148px;
}

.lampBoxPosition {
  top: 4%;
  left: 35%;
}

.lampBoxPosition2 {
  top: 4%;
  left: 56%;
}

.lampBoxPosition3 {
  top: 22%;
  left: 80%;
}

.lampBoxPosition4 {
  top: 54%;
  left: 89%;
}

.lampBoxPosition5 {
  top: 83%;
  left: 64%;
}

.lampBoxPosition6 {
  top: 84%;
  left: 40%;
}

.lampBoxPosition7 {
  top: 79%;
  left: 21%;
}

.lampBoxPosition8 {
  top: 23%;
  left: 13%;
}

.lampText {
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  margin: 27px 0;
}

.hiddleCssTwo {
  margin-left: 50px;
}

.hiddleCssTwoText {
  padding-left: 44px;
}

.lampContent:hover .hiddleCss {
  display: block;
}

/* 呼吸灯 start */
.breath_light {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light1 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath1;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light2 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath2;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath2;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light3 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath3;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath3;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light4 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath4;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath4;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light5 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath5;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath5;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light6 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath6;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath6;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

.breath_light7 {
  border-radius: 50%;
  opacity: 0.26;
  /* 不透明度 */
  overflow: hidden;
  /* 溢出隐藏 */
  /* background: #FF3; */
  /* 背景色 */
  /* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
  animation-name: breath7;
  /* 动画名称 */
  animation-duration: 3s;
  /* 动画时长3秒 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  animation-iteration-count: infinite;
  /* 播放次数：无限 */

  /* Safari and Chrome */
  -webkit-animation-name: breath7;
  /* 动画名称 */
  -webkit-animation-duration: 3s;
  /* 动画时长3秒 */
  -webkit-animation-timing-function: ease-in-out;
  /* 动画速度曲线：以低速开始和结束 */
  -webkit-animation-iteration-count: infinite;
  /* 播放次数：无限 */
}

@keyframes breath {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  50% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath1 {
  from {
    opacity: 0.7;
  }

  /* 动画开始时的不透明度 */
  50% {
    opacity: 0.1;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.7;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath2 {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  20% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath3 {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  80% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath4 {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  20% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath5 {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  70% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath6 {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  10% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

@-webkit-keyframes breath7 {
  from {
    opacity: 0.1;
  }

  /* 动画开始时的不透明度 */
  80% {
    opacity: 0.7;
  }

  /* 动画50% 时的不透明度 */
  to {
    opacity: 0.1;
  }

  /* 动画结束时的不透明度 */
}

/* 呼吸灯 end */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.videoHeight {
  width: 100%;
}

.videoBg {
  overflow: hidden;
}

.advantageImg {
  width: 100%;
}

.advantage {
  position: relative;
}

.advantageBox {
  position: absolute;
  width: 70%;
  height: 70%;
  max-height: 300px;
  top: calc(50% - 27%);
  left: calc(50% - 40%);
}
@media screen and (min-width: 1300px) {
  .advantageBox {
    top: 28%;
  }
}

.advantageBox::after {
  content: "";
  display: block;
  clear: both;
}

.advantageLeft {
  width: 50%;
  float: left;
  padding-left: 2%;
}

.advleftBox {
  width: 80%;
}

.advantageRight {
  width: 48%;
  float: right;
  text-align: center;
}

.advTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  margin-bottom: 8%;
}
.advText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 34px;
}
.rightFlex {
  display: flex;
  flex-wrap: wrap;
  width: 95%;
}
.rightBox {
  text-align: center;
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  width: 25%;
  height: 60px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 72% 100%;
  background-position: 50% 60%;
}
.rightBox img {
  width: 52%;
}

.marginTop84 {
  margin-top: 21%;
}
.wisdomCss {
  font-size: 5rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
}
.spanCss {
  display: inline-block;
  position: relative;
  width: 189px;
}
.addCss {
  display: inline-block;
  position: absolute;
  top: -21px;
  font-size: 7.7rem;
}
.bottomText {
  position: absolute;
  top: 90%;
  width: 100%;
}
.showGif {
  display: inline-block;
}
.notShowGif {
  display: none;
}
/* 头部的轮播图 start */
.swiper-button-next, .swiper-button-prev{
  width: 56px !important;
  height: 56px !important;
}


.swiper-button-next{
  background-image: url("../assets/images/swiperToRightIconTop.png");
  background-size: 100%;
  opacity: .35 !important;
}
.swiper-button-prev{
  background-image: url("../assets/images/swiperToLeftIconTop.png");
  background-size: 100%;
  opacity: .35 !important;
}
.swiper-button-prev:hover{
  opacity: 1 !important;
}
.swiper-button-next:hover{
  opacity: 1 !important;
}
/* 头部的轮播图 end */
</style>



// WEBPACK FOOTER //
// src/view/Home.vue